export default "__VITE_ASSET__BoqzwHsI__"